<template>
    <div>
        <b-table 
            striped 
            hover 
            selectable 
            select-mode="single" 
            :items="users" 
            :fields="fields" 
            :per-page="perPage"
            :current-page="currentPage">            
        </b-table>

        <TablePagination 
            :total-rows="totalRows" 
            :per-page="perPage" 
            @pageChange="onPageChange">
        </TablePagination>
    </div>
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'

export default {
    components: { TablePagination },
        props: {
            item: {
                required: true,
            }
        },
        data() {
            return {
                perPage: 15,
                currentPage: 1,
                fields: [
                    { key: "id", label: this.$t('users.id') },
                    { key: "name", label: this.$t('users.name'),
                        formatter: (value, key, item) => {
                        return item.firstname + ' ' + item.lastname;
                        }
                    },
                ],
                users: []
            }
    },
    computed: {
        totalRows() {
            return this.users ? this.users.length : 0;
        }
    },
    created() {
        this.getUsers(this.item.id);
        
    },
    watch: {
        item: function(item) {
            this.getUsers(item.id);           
        }
    }, 
    methods: {
        getUsers(id) {
            var groupUsers = [];
            var users = this.$store.state.userDataHandler.users.list;
            users.forEach(function (user) {
                if(user.usergroups) {
                    user.usergroups.forEach(function (usergroup) {
                       if(usergroup.id == id){
                            groupUsers.push(user);
                       }
                      
                    });
                }
            });
            

            this.users = groupUsers;
       },
       onPageChange(page){
            this.currentPage = page
       }
    }
}
</script>
